function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconReturnArrowFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.927 18.265l-3.513 3.513H30v2H5.414l3.513 3.515-1.414 1.414-5.928-5.929 5.928-5.927 1.414 1.414zM30.414 9.22l-5.928 5.928-1.414-1.414 3.514-3.514H2v-2h24.586l-3.514-3.514 1.414-1.414 5.928 5.928z",
    fill: props.color
  }));
}

export default SvgIconReturnArrowFilled;